<template>
    <main>
        <section class="card">
            <header>
                <span class="active">
                    <span class="hd">1</span>
                    <span class="title">身份证信息录入</span>
                </span>
                <span>
                    <span class="hd">2</span>
                    <span class="title">人脸核验</span>
                </span>
            </header>
            <section class="middle">
                <span>请确认下列信息是否与证件一致， 如信息有误请修改</span>
                <div>
                    <span>姓 名</span>
                    <input ref="name" />
                </div>
                <div>
                    <span>证件号</span>
                    <input ref="idno" />
                </div>
            </section>
            <div class="footer">
                <div>
                    <van-button @click="back()" class="backbtn">重新上传</van-button>
                    <van-button @click="nextStep()" type="info">下一步</van-button>
                </div>
            </div>
        </section>

    </main>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

export default {
  name: "idcardconfirm",
  data() {
    return {};
  },
  mounted() {
    this.$refs.name.value = this.$route.query.name;
    this.$refs.idno.value = this.$route.query.idcard;
  },

  beforeDestroy() {},

  methods: {
    back() {
      this.$router.back();
    },
    nextStep() {
      Toast.loading({
        duration: 0,
        forbidClick: true,
        className: "loading",
        loadingType: "spinner",
        message: "提交中"
      });
      let frontendConfig = this.$store.state.dynamic.frontendConfig || [];
      //配置项判断是否“校验实名认证时的姓名身份证号和登录者信息是否一致”
      let is_check_idCard = "false";
      let arr = frontendConfig.filter(item => {
        return item.key == "is_check_idCard";
      });
      if(arr.length>0 ){
        is_check_idCard = arr[0].value;
      }
      let apiName =
        is_check_idCard == "true" ? "slhIdcardAffirm" : "idcardAffirm";
      this.$api.face[apiName]({
        data: {
          idcardNumber: this.$refs.idno.value,
          name: this.$refs.name.value
        }
      })
        .then(res => {
          Toast.clear();
          if (res.success) {
            this.$router.replace({
              path: "/scan",
              query: {
                courseId: this.$route.query.courseId,
                trainId: this.$route.query.trainId || "",
                studyProcess: this.$route.query.studyProcess,
                backType: this.$route.query.backType,
                trainItemExamId: this.$route.query.trainItemExamId,
                type: this.$route.query.type,
                contentId: this.$route.query.contentId,
                id: this.$route.query.id,
                refId: this.$route.query.refId,
                refType: this.$route.query.refType,
                respondlink: this.$route.query.respondlink
              }
            });
          } else {
            this.$notify({
              duration: 6000,
              type: "danger",
              message: `身份信息确认失败,${res.message}`
            });
          }
        })
        .catch(err => {
          Toast.fail(err);
          Toast.clear();
        });
    }
  }
};
</script>
<style scoped>
main * {
  position: relative;
}
main {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100vh;
  /* top: 0px;
        right: 0px;
        bottom: 0px;
        left: 0px; */
  align-items: center;
  background: #f7f7f7;
}

main > section.card {
  background: white;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 28px;
  left: 28px;
  right: 28px;
}

header {
  width: 100%;
  display: flex;
  justify-content: space-around;
  text-align: center;
  margin: 30px 0px;
}

header > span {
  display: inline-block;
  color: #737386;
}

header > span > span.hd {
  background-color: #d7dfff;
  color: white;
  text-align: center;
  display: inline-block;
  border-radius: 24px;
  width: 50px;
  height: 50px;
  margin: 0px 10px;
  line-height: 50px;
}

header > span.active {
  color: #3660ff;
}

header > span.active:after {
  content: "";
  border-top: solid 1px rgba(54, 96, 255, 0.4);
  position: absolute;
  top: 25px;
  right: -70px;
  width: 60px;
  height: 1px;
}

header > span.active > span.hd {
  background-color: #3660ff;
}

header > span > span.title {
  line-height: 50px;
  top: 2px;
}

section.middle {
  margin: 0px 32px;
}

section.middle > span {
  color: #202124;
  font-size: 30px;
  margin: 20px 0px;
  display: inline-block;
}

section.middle > div {
  display: flex;
  background: #f7f7f7;
  height: 96px;
  margin: 24px 0px;
  border-radius: 12px;
}

section.middle > div > span {
  display: inline-block;
  font-size: 28px;
  margin: 0px 35px;
  color: #737386;
  width: 90px;
  line-height: 96px;
  text-align: justify;
  text-align-last: justify;
}
section.middle > div > span:after {
  content: ":";
  position: absolute;
  top: 0px;
  right: -16px;
}

section.middle > div > input {
  flex: 1;
  border-width: 0px;
  background: #f7f7f7;
  font-size: 32px;
  color: #202124;
  border-radius: 12px;
}

.footer {
  margin: 40px 0px !important;
  width: 100%;
}

.footer > div {
  display: flex;
  margin: 0px 18px;
}

.footer > div > button {
  flex: 1;
}

.van-button {
  border-radius: 22px;
  font-size: 18px;
  margin: 0px 8px;
}

.backbtn {
  border: solid 1px #3660ff;
  color: #3660ff;
}
</style>